import { deleteItem, getList, postItem } from "./utils/entity-network-requests"

import { stakeholderBaseUrl } from "./utils/network-config"

const getEntityName = (stakeholderID, roleID) => {
    return `stakeholder/${stakeholderID}/role/${roleID}/evidence`
}

export const getEvidenceList = (token, stakeholderID, roleID) => {
    const entityName = getEntityName(stakeholderID, roleID)
    return getList(entityName, undefined, token, stakeholderBaseUrl)
}

export const postEvidenceUrl = (token, link) => {
    return postItem("knowledge?simple=true", { link }, token)
}

export const postEvidenceItem = (token, stakeholderID, roleID, evidence) => {
    const entityName = getEntityName(stakeholderID, roleID)
    return postItem(entityName, evidence, token, stakeholderBaseUrl)
}

export const deleteEvidenceItem = (
    token,
    stakeholderID,
    roleID,
    evidenceID
) => {
    const entityName = getEntityName(stakeholderID, roleID)
    return deleteItem(entityName, evidenceID, token, stakeholderBaseUrl)
}
